import React from 'react';
import { take, takeRight, throttle } from 'lodash';
import { renderToolbarInPortal, RicosButton } from './external-toolbar-utils';
import { MorePluginsMenu } from './more-plugins-menu';
import { useApi } from '../../../context/api-context/use-api';
import { getIsMobile } from '../../../../common/store/base-params/base-params-selectors';
import { COMMENT_BOX_TOOLBAR } from '../../../../common/constants/data-hooks';
import { EXTERNAL_PLUGIN_TOOLBAR_ID } from '../../portals/ricos-plugin-toolbar-portal';
import { TooltipLazy } from '../../tooltip-lazy/tooltip-lazy';
import { isResizeObserverSupported } from '../../../../common/utils/is-resize-observable-supported';
import { st, classes } from './external-plugin-toolbar.st.css';
const IconWidth = 24;
const IconGap = 20;
const getAmountThatFits = (containerWidth, buttonSize) => {
    const amount = Math.floor(containerWidth / buttonSize);
    return amount > 0 ? amount : 0;
};
const ExternalPluginToolbar = ({ containerRef, ...props }) => {
    const [containerWidth, setContainerWidth] = React.useState(() => containerRef?.getBoundingClientRect().width ?? 0);
    const isMobile = useApi((state) => getIsMobile(state));
    const buttons = Object.values(props.buttons);
    const amountThatFits = containerRef
        ? getAmountThatFits(containerWidth, IconWidth + IconGap)
        : buttons.length;
    React.useLayoutEffect(() => {
        if (containerRef && isResizeObserverSupported()) {
            const resizeObserver = new window.ResizeObserver(throttle((entries) => {
                if (containerWidth !== entries[0].contentRect.width) {
                    setContainerWidth(entries[0].contentRect.width);
                }
            }, 300));
            resizeObserver.observe(containerRef);
            return () => {
                resizeObserver.disconnect();
            };
        }
    }, [containerRef]);
    const amountToDisplayInToolbar = isMobile
        ? 0
        : amountThatFits >= buttons.length
            ? buttons.length
            : amountThatFits - 1; // take into account the plugin menu button
    const amountToDisplayInMenu = isMobile
        ? buttons.length
        : buttons.length - amountToDisplayInToolbar;
    return (React.createElement("div", { "data-hook": COMMENT_BOX_TOOLBAR, className: st(classes.root, { isMobile }), style: { gap: IconGap } },
        take(buttons, amountToDisplayInToolbar).map((buttonProps) => (React.createElement("div", null,
            React.createElement(TooltipLazy, { className: classes.tooltip, content: buttonProps.tooltip, minWidth: 120, moveBy: { x: 0, y: 2 }, disabled: isMobile, showDelay: 300, appendTo: "window" },
                React.createElement(RicosButton, { ...buttonProps, className: classes.pluginButton, iconClass: classes.pluginIcon, iconStyle: {
                        width: IconWidth,
                    } }))))),
        amountToDisplayInMenu ? (React.createElement(MorePluginsMenu, { buttons: takeRight(buttons, amountToDisplayInMenu), isExtended: isMobile ? true : !!amountToDisplayInToolbar })) : null));
};
export default renderToolbarInPortal(ExternalPluginToolbar, EXTERNAL_PLUGIN_TOOLBAR_ID);
//# sourceMappingURL=external-plugin-toolbar.js.map